import { render, staticRenderFns } from "./PaginationSlideshow.vue?vue&type=template&id=31f78400&scoped=true"
import script from "./PaginationSlideshow.vue?vue&type=script&lang=js"
export * from "./PaginationSlideshow.vue?vue&type=script&lang=js"
import style0 from "./PaginationSlideshow.vue?vue&type=style&index=0&id=31f78400&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f78400",
  null
  
)

export default component.exports